import { Typography, withStyles } from '@material-ui/core';
import React from 'react';
import styles from '../../style';

interface Props {
  classes?: any;
}
const Cheque = (props: Props) => {
  const { classes } = props;

  return (
    <div className={classes.blocCheque}>
      <Typography variant="h5">Renouveler par chèque</Typography>
      <p>
        Adressez votre règlement par chèque à l'ordre de <strong>SAGA SERVICE PLUS</strong> à :<br />
      </p>
      <p className={classes.adresse}>
        SAGA SERVICE PLUS
        <br />
        46, bis rue des Hauts Pavés
        <br />
        BP 52216
        <br />
        44022 NANTES Cédex 01
      </p>
      <p>
        <br />
        En y indiquant votre numéro d'adhésion et/ou votre numéro d'immatriculation.
        <br />
        Vous recevrez une confirmation de renouvellement lorsque votre demande aura été traitée.
      </p>
    </div>
  );
};
export default withStyles(styles)(Cheque);
